import { addDoc, collection, serverTimestamp } from "firebase/firestore";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { db } from "../../../firebase";
import { useAuth } from "../../components/authContext";
import StyledButton from "../components/button";
import FileUploadButton from "../components/fileUpload"; // adjust path if needed
import PurchaseHistory from "./purchaseHistory";

const FoodBudget: React.FC = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [selectedFile, setSelectedFile] = useState<File | null>(null);
  const [uploading, setUploading] = useState(false);

  useEffect(() => {
    if (!user) navigate("/login");
  }, [user, navigate]);

  const fileToBase64 = (file: File): Promise<string> =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => resolve(reader.result as string);
      reader.onerror = reject;
      reader.readAsDataURL(file);
    });

  const handleUpload = async () => {
    if (!selectedFile || !user) return;
    setUploading(true);

    try {
      const base64 = await fileToBase64(selectedFile);

      const response = await fetch("/.netlify/functions/parse-receipt", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ base64 }),
      });

      const { rawText } = await response.json();

      const newDocRef = await addDoc(
        collection(db, `users/${user.uid}/purchases`),
        {
          uid: user.uid,
          createdAt: serverTimestamp(),
          rawText,
          store: "",
          tax: 0,
          total: 0,
          items: [],
          status: "draft", // optionally use this to filter unreviewed receipts
        }
      );

      navigate(`/foodbudget/edit/${newDocRef.id}`);
    } catch (err) {
      console.error("❌ Upload Error:", err);
    } finally {
      setUploading(false);
      setSelectedFile(null);
    }
  };

  const handleTakePicture = async () => {
    const input = document.createElement("input");
    input.type = "file";
    input.accept = "image/*";
    input.capture = "environment";
    input.onchange = async (e: any) => {
      if (e.target.files && e.target.files[0]) {
        setSelectedFile(e.target.files[0]);
      }
    };
    input.click();
  };

  if (!user) return null;

  return (
    <div style={{ padding: "2rem" }}>
      <h1>Food Budget</h1>
      <p>Welcome, {user.displayName}</p>

      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "10px",
          marginBottom: "1rem",
        }}
      >
        <FileUploadButton onFileSelected={(file) => setSelectedFile(file)} />

        <StyledButton onClick={handleTakePicture}>📷 Take Picture</StyledButton>

        {selectedFile && (
          <span style={{ fontSize: "14px", color: "#333" }}>
            {selectedFile.name}
          </span>
        )}
      </div>

      <StyledButton
        onClick={handleUpload}
        disabled={!selectedFile || uploading}
      >
        {uploading ? "Uploading..." : "Upload Receipt"}
      </StyledButton>

      <hr />
      <PurchaseHistory uid={user.uid} />

      <div style={{ marginTop: "16px" }}>
        <StyledButton onClick={logout}>Logout</StyledButton>
      </div>
    </div>
  );
};

export default FoodBudget;
